import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '351px',
  height: '200px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '48px 24px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
};

function ConfirmModal({
  open = null,
  setOpen,
  title = null,
  content = null,
  cancelLabel = '',
  confirmLabel = '',
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(null)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {title !== null && <div>{title}</div>}
        <div className="w-full flex flex-col items-center justify-center text-[14px] font-[400]">
          {content?.split('\n')?.map(str => (
            <div key={str}>{str}</div>
          ))}
        </div>
        <div className="flex w-full items-center justify-center gap-2">
          <Button
            variant="gray"
            onClick={() => {
              setOpen(null);
              onCancel();
            }}
            sx={{ width: '113px' }}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="dark"
            onClick={() => {
              setOpen(null);
              onConfirm();
            }}
            sx={{ width: '113px' }}
          >
            {confirmLabel}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmModal;
